export type UiFlowNodeType =
  | 'process'
  | 'terminator'
  | 'document'
  | 'decision'
  | 'connector'
  | 'off-page'
  | 'io'
  | 'note';
export type UiFlowMarkerTone = 'success' | 'error' | 'neutral';
export type UiFlowMarkerVariant = 'icon' | 'text' | 'none';
export type UiFlowConnectorOrientation = 'horizontal' | 'vertical';
export type UiFlowConnectorStyle = 'solid' | 'dashed';

export interface UiFlowNode {
  id: string;
  type: UiFlowNodeType;
  label: string;
  /** Columna 1-based en el lienzo. */
  col: number;
  /** Fila 1-based en el lienzo. */
  row: number;
  /** Texto secundario opcional bajo el nodo. */
  caption?: string;
  /** Si es true, el nodo es clickeable y emite `nodeClick` en el diagrama. */
  interactive?: boolean;
}

export interface UiFlowEdge {
  id: string;
  from: string;
  to: string;
  style?: UiFlowConnectorStyle;
  marker?: UiFlowMarkerTone;
  /**
   * Presentación del resultado en el tramo:
   * - `icon` (default): círculo ✓/✕ (+ tooltip con label)
   * - `text`: label centrado sobre la línea
   * - `none`: sin marker ni texto en el tramo
   */
  markerVariant?: UiFlowMarkerVariant;
  label?: string;
  /**
   * `gap-left`: baja por el hueco a la izquierda del origen y entra al destino
   * por su costado, sin cruzar los nodos de esa columna.
   */
  route?: 'gap-left';
}

/** ¿La arista reserva espacio / pinta meta de marker? */
export function uiFlowEdgeHasMarkerMeta(edge: UiFlowEdge): boolean {
  const variant = edge.markerVariant ?? 'icon';
  if (variant === 'none') return false;
  if (variant === 'text') return !!edge.label;
  return !!edge.marker;
}
